import React from 'react';
import { connect } from 'react-redux';
import Config from '../../../../../Config';
import Property from '@episerver/spa-core/Components/Property';
import Checkbox from '../../../../Shared/CheckBox/Checkbox';
import { goToPage, setIsCheckedCollaborationApproval, } from '../../MovingBlockSlice';
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import ThirdParty from '../../../../Shared/ThirdParty/ThirdParty';

const CollaborationApproval = (props) => {
  function handleCollaborationApprovalChanged(checkbox) {
    props.setIsCheckedCollaborationApproval(checkbox);
  }

  return (
    <>
      <div className='collaboration-approval-container'>
        <div className='collaboration-approval-input'>
          <Checkbox
            id='agreementCheckbox'
            onCheck={() => handleCollaborationApprovalChanged(true)}
            onUncheck={() => handleCollaborationApprovalChanged(false)}
            checked={props.isCollaborationApproval}
            label={''}
          />
          <span>
            <ThirdParty/>
          </span>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = { setIsCheckedCollaborationApproval };

export default connect(mapStateToProps, mapDispatchToProps)(CollaborationApproval);
